(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["enquiry-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.enquiry-button__link');
    if (!link) return;
    const target = document.getElementById('product-enquiry');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const field = target.querySelector('input[name="contact[name]"]');
    if (field) setTimeout(() => field.focus({ preventScroll: true }), 600);
  });
  } catch(e) { console.error(e); }
})();

})();
